module.exports = __webpack_public_path__ + "static/media/smriti.388dd805.jpg";